import WaypointHandler from '@/scripts/Components/libs/waypoint-handler';

const mergeContent = (oldList, newList) => {
  const list = {};
  oldList.forEach((item) => { list[item.id || item.uid] = item; });
  newList.forEach((item) => { list[item.id || item.uid] = item; });
  return Object.entries(list).map(([key, value]) => value);
};

export default {
  created() {
    // Validate component for required property
    [
      'loading',
      'waypoint',
      'hasMorePages',
      'response',
      'error',
    ].forEach((property) => {
      if (this[property] === undefined) {
        throw new Error(`The property \`${property}\` must be defined.`);
      }
    });

    // Allow overriding of content name. Default to videos
    this.profileVideoLoadingMixin_contentName = this.profileVideoLoadingMixin_contentName || 'items';
  },

  methods: {
    profileVideoLoadingMixin_runLoadVideoSequence() {
      this.profileVideoLoadingMixin_updatePreUiState();
      this.profileVideoLoadingMixin_loadVideos()
        .then(this.profileVideoLoadingMixin_processVideos)
        .then(this.profileVideoLoadingMixin_updatePostUiState)
        .catch(this.profileVideoLoadingMixin_handleError)
      ;
    },

    profileVideoLoadingMixin_refreshLoadVideoSequence() {
      this.profileVideoLoadingMixin_updatePreUiState();

      const originalResponse = {
        page: this.response.page,
        perPage: this.response.perPage,
      };
      this.response.page = -1;
      this.response.perPage = this.response[this.profileVideoLoadingMixin_contentName].length;

      this.profileVideoLoadingMixin_loadVideos()
        .then(this.profileVideoLoadingMixin_processVideos)
        .then((result) => {
          // Restore response state
          this.response.page = originalResponse.page;
          this.response.perPage = originalResponse.perPage;
          // Refresh content
          this.response[this.profileVideoLoadingMixin_contentName] = [];
          return result;
        })
        .then(this.profileVideoLoadingMixin_updatePostUiState)
        .catch((error) => {
        // Restore response state
          this.response.page = originalResponse.page;
          this.response.perPage = originalResponse.perPage;
          // Pass error down
          throw error;
        })
        .catch(this.profileVideoLoadingMixin_handleError)
      ;
    },

    // Update UI State
    profileVideoLoadingMixin_updatePreUiState() {
      if (this.waypoint) this.waypoint.destroy();
      this.loading = true;
      this.error = false;
    },

    // Load videos: Please override this function to your need
    profileVideoLoadingMixin_loadVideos() {
      return Promise.resolve({});
    },

    // Process Data;
    profileVideoLoadingMixin_processVideos(result) {
      return result;
    },

    // Update UI State
    profileVideoLoadingMixin_updatePostUiState(result) {
      this.loading = false;

      this.response = {
        ...result,
        // Concatenate videos
        [this.profileVideoLoadingMixin_contentName]: mergeContent(
          this.response[this.profileVideoLoadingMixin_contentName],
          result[this.profileVideoLoadingMixin_contentName],
        ),
      };

      if (this.waypoint) {
        this.waypoint.update();

      // Create waypoint only if necessary and if the `seeMoreElement` element is available
      } else if (this.hasMorePages && this.$refs.seeMoreElement) {
        this.waypoint = new WaypointHandler({
          element: this.$refs.seeMoreElement,
          handler: this.profileVideoLoadingMixin_runLoadVideoSequence,
          offset: 'bottom-in-view',
          destoyOnTrigger: true,
        }, () => this.hasMorePages);
      }
    },

    profileVideoLoadingMixin_handleError(error) {
      this.loading = false;

      // Ignore information about access forbidden
      if (error.message === 'Access Forbidden') {
        return;
      }

      this.error = error.message;
      throw error;
    },
  },
  beforeDestroy() {
    if (this.waypoint) this.waypoint.destroy();
  },
};
